<template>
  <div class="container">
    <div class="header">
      <div class="title">
        <span v-if="props.type === 'Treatment' || !props.title.includes('NCT')">{{ props.title }}</span>
        <a v-else :href="'https://classic.clinicaltrials.gov/ct2/show/' + props.title" target="_blank">{{ props.title
        }}</a>
      </div>
      <div class="close-icon">
        <span class="material-symbols-outlined" @click="closeModal">close</span>
      </div>
    </div>
    <div class="text">
      <span>{{ props.text }}</span>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { defineEmits, defineProps } from 'vue'

const props = defineProps({
  title: String,
  text: String,
  type: String,
})

const emit = defineEmits(['closeDetailsModal'])

const closeModal = () => {
  emit('closeDetailsModal')
}
</script>

<style lang="scss" scoped>
.close-icon {
  user-select: none;
  cursor: pointer;
}

.container {
  height: 100%;
  background-color: #F7F9FB;
  color: var(--Black);
  font-size: 11.34px;
  text-align: left;
  overflow: auto;
}

.title {
  margin-left: 10px;
  font-size: 14px;
  font-style: bold;
}

.text {
  margin: 10px;
}

.header {
  margin: 5px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>
